import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { COMPANY_PAYMENT_MESSAGE, COMPANY_PAYMENT_WARNING_MESSAGE } from '../util/companyPaymentAccess';
import { acknowledgeCompanyPaymentWarning } from '../appRedux/actions/Auth';

const CompanyPaymentNotice = () => {
  const { authUser, blockedCompany, warningCompany } = useSelector(({ auth }) => auth);
  const authenticated = Boolean(authUser);
  const history = useHistory();
  const dispatch = useDispatch();
  const pendingNotice = useRef(null);
  const currentSession = useRef(null);
  currentSession.current = { authUser, blockedCompany, warningCompany };

  useEffect(() => {
    const company = blockedCompany || warningCompany;
    const cancelled = Boolean(blockedCompany);
    if (!authenticated || !company) {
      if (pendingNotice.current) {
        pendingNotice.current = null;
        Swal.close();
      }
      return;
    }
    const key = `${cancelled ? 'cancelled' : 'warning'}:${company.sessionId || ''}:${company.companyId}`;
    if (pendingNotice.current?.key === key) return;
    if (pendingNotice.current) {
      pendingNotice.current = null;
      Swal.close();
    }

    const notice = { key, cancelled, company };
    const confirmation = Swal.fire({
      title: cancelled ? 'Servicio suspendido' : 'Servicio en riesgo de suspensión',
      text: cancelled ? COMPANY_PAYMENT_MESSAGE : COMPANY_PAYMENT_WARNING_MESSAGE,
      icon: cancelled ? 'error' : 'info',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    pendingNotice.current = notice;
    confirmation.then(result => {
      if (pendingNotice.current !== notice) return;
      pendingNotice.current = null;
      if (!result?.isConfirmed || !currentSession.current.authUser) return;
      if (notice.cancelled) {
        if (currentSession.current.blockedCompany) history.replace('/companyGroup');
      } else if (!currentSession.current.blockedCompany &&
        currentSession.current.warningCompany?.companyId === notice.company.companyId &&
        currentSession.current.warningCompany?.sessionId === notice.company.sessionId) {
        dispatch(acknowledgeCompanyPaymentWarning(currentSession.current.warningCompany));
      }
    });
  }, [authenticated, blockedCompany, warningCompany, dispatch, history]);

  useEffect(() => () => {
    if (pendingNotice.current) {
      pendingNotice.current = null;
      Swal.close();
    }
  }, []);

  return null;
};

export default CompanyPaymentNotice;
